import { useQuery } from '@tanstack/react-query'
import { fetchAllMaterials, fetchAllPrinters } from '$api/evoAPIs'

const useAvailableMaterials = () => {
  const { data: materialsPage, isSuccess: materialsSuccessfullyLoaded } =
    useQuery(['materials'], () =>
      fetchAllMaterials({ queryKey: ['materials', { size: 100 }] }),
    )

  const { data: allPrinterMaterials, isSuccess: printersSuccessFullyLoaded } =
    useQuery(['printers'], fetchAllPrinters, {
      select: (response) =>
        response.items.reduce((allPrinterMaterials, printer) => {
          if (printer.materials) {
            printer.materials.forEach((materialId) => {
              allPrinterMaterials.add(materialId)
            })
          }
          return allPrinterMaterials
        }, new Set()),
    })

  if (materialsSuccessfullyLoaded && printersSuccessFullyLoaded) {
    const materials = materialsPage?.items || []
    return materials.map((material) => ({
      ...material,
      printerAvailable: allPrinterMaterials.has(material.id),
    }))
  }

  return []
}

export default useAvailableMaterials
